import React from 'react';
import { useIntl } from 'react-intl';
import * as TFF from '@tff/types/tff';
import TFFIcon from '../../styled-components/TFFIcon';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFAccordionNew from '../../styled-components/TFFAccordionNew';
import flexMockUpData from './flexMockUpData.json';
import FlexOptionDetails from './FlexOptionDetails';
import { useBookingContext } from '../../hooks/use-booking-context';

interface props {
  flexResponse?: TFF.ServicePackageConnectorResponse;
}

const FlexOptionCard: React.FC<props> = ({ flexResponse }) => {
  const intl = useIntl();
  const { costFormatter, currency } = useBookingContext();

  return (
    <TFFAccordionNew
      accordionId="flex-card"
      detailsColor="#FFF"
      summaryChildren={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '50px',
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
              <TFFIcon iconName="euro-return" color="color-theme-variant" />
              <TFFTypography variant="lead" fontWeight="bold" text={intl.formatMessage({ id: 'flexOption.title' })} />
            </div>
            <TFFTypography
              // refactor error handling when mockupdata is updated with a request
              text={`${flexMockUpData?.flexOption.selectedFlexOptions.map(flexTitle => flexTitle.name).join(' + ')}`}
              color="color-functional-neutral-900"
            />
            <span style={{ color: 'red' }}>TEST!!</span>
          </div>

          <TFFTypography
            // refactor error handling when mockupdata is updated with a request
            text={costFormatter.format(
              flexMockUpData?.flexOption.selectedFlexOptions
                .map(flexPrice =>
                  flexPrice.passengers.reduce((sum, passenger) => sum + (passenger.productPrice || 0), 0),
                )
                .reduce((acc, num) => acc + num, 0),
            )}
            color="color-theme-variant"
            fontWeight="bold"
          />
        </div>
      }
      detailsChildren={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '4px',
            minHeight: '250px',
            width: '100%',
            padding: '0px 12px',
            margin: '-15px 0px',
          }}
        >
          <>
            {/* refactor error handling when mockupdata is updated with a request */}
            {flexMockUpData?.flexOption.selectedFlexOptions.map((flexData, index) => (
              <FlexOptionDetails
                isExpiredYet={flexData.productParameters.daysPriorToDeparture > 0}
                flexName={flexData.name}
                flexPrices={flexData}
                flexPassengers={flexData}
                index={index}
                key={flexData.productId}
              />
            ))}
          </>
          <div
            style={{
              fontSize: '16px',
              paddingTop: 20,
              paddingBottom: 20,
              color: ' var(--color-functional-neutral-600) ',
            }}
          >
            {`All Prices are in ${currency}`}
          </div>
        </div>
      }
    />
  );
};

export default FlexOptionCard;
